module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAXCAYAAAD6FjQuAAABLElEQVRIie3WvUoDQRSG4WcTf6JRFEGwsfYCUom5AGsbS0El1raC2ii2FtYW3oEINmJnIwTsBAst1MYiFgpBYkwsMsKyRuIGGyEfDGdm9nz77hkG9kSFUhl2sIxJNLRXBefYxh0i7GEB08iimfBkUMUpVqNCqbyB3fCwir6EoRlGLrZewhrmwt47PsLL46pjOMwvMthCDVPIYzAxchjCGNZDRUcBdBiqGgg5SW8+7F+imAmbFTy1Obq4XrCPg7C+wgoeO/jecC1WdraDIa6TEM9SeEbisDSKQkxeho7qBvZ1gdKcRtewrtWD9WA9WA/2z2A/tQJ/pUYc1p/C+BDicwpPjdbv4gYzWu3Bre89SFx1zIb5PO5/kT+ORYgKpXIRx5hI8aWvGE2R38TmJ9ZmNRfAFEgzAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/pages/uc/images/yuedu.png
// module id = +Gfy
// module chunks = 1